export default __webpack_public_path__ + "96a40155493f2c172a8c7a4d0c687010-bnpenandgram-regular-webfont.woff";